export const VALUEEXPERTS_ENGLISH = {
  "datox.ve.notes.eyebrow": "Review context",
  "datox.ve.notes.title": "Source notes & limitations",
  "datox.ve.notes.description": "Document-level observations from the extraction. Open a source to understand its limitations and the basis for your review.",
  "datox.ve.notes.count": "Notes: {{count}}",
  "datox.ve.notes.search": "Search documents or notes…",
  "datox.ve.notes.expand": "Expand all",
  "datox.ve.notes.collapse": "Collapse all",
  "datox.ve.notes.source": "Source document",
  "datox.ve.notes.general": "Extraction context",
  "datox.ve.notes.generalTitle": "Additional analysis notes",
  "datox.ve.notes.original": "Original extraction observations",
  "datox.ve.notes.openSource": "Open source document",
  "datox.ve.notes.noMatches": "No documents or notes match your search.",
  "datox.ve.notes.clearSearch": "Clear search",
  "datox.ve.notes.guidance": "These notes describe the source material. Use the current findings and approved company record to determine outstanding actions; a source caveat does not reopen a resolved finding.",
  "datox.ve.reports.title": "Connected reports",
  "datox.ve.reports.description": "Generate three printable reports from one dated snapshot of reviewed records, milestones and obligations.",
  "datox.ve.reports.scope": "Portfolio engagements",
  "datox.ve.reports.client": "Client progress engagement and report workspace",
  "datox.ve.reports.scopeHint": "Engagement and Compliance cover the selected portfolio. Client Progress contains only the selected client engagement. Source-project permissions apply to portfolio reports.",
  "datox.ve.reports.generate": "Generate three reports",
  "datox.ve.reports.regenerate": "Refresh report bundle",
  "datox.ve.reports.generating": "Generating connected reports…",
  "datox.ve.reports.stale": "Sources or reporting date changed. Refresh this bundle.",
  "datox.ve.reports.asOf": "As of {{date}} · Asia/Riyadh",
  "datox.ve.reports.empty": "Create an engagement to generate connected reports.",
  "datox.ve.reports.engagement_management": "Engagement Management Report",
  "datox.ve.reports.compliance_obligations": "Compliance & Obligations Report",
  "datox.ve.reports.client_progress": "Client Entity Progress Report",
  "datox.ve.reports.description.engagement_management": "Portfolio progress, outstanding documents, dependencies and accountable next actions.",
  "datox.ve.reports.description.compliance_obligations": "Verified deadlines, overdue items, source provenance and proposals awaiting activation.",
  "datox.ve.reports.description.client_progress": "Client-visible milestones, outstanding requests and verified entity obligations.",
  "datox.ve.reports.internal": "Internal portfolio report",
  "datox.ve.reports.clientFacing": "Client-facing report",
  "datox.ve.title": "Company Setup & Compliance",
  "datox.ve.brand": "Corporate Services",
  "datox.ve.description": "From a document pack to a reviewed company record, draft documents and an obligations calendar.",
  "datox.ve.prototype": "Connected prototype · Internal workspace",
  "datox.ve.scope": "Government submissions remain manual. Client portal access and automatic reminder scheduling are planned capabilities.",
  "datox.ve.sample": "Synthetic demonstration · All documents, identities and dates are test data.",
  "datox.ve.new": "Create engagement",
  "datox.ve.sample.name": "New company engagement",
  "datox.ve.open": "Open engagement",
  "datox.ve.portfolio": "Portfolio",
  "datox.ve.name": "Engagement name",
  "datox.ve.project": "Client workspace",
  "datox.ve.project.new": "Create a new workspace",
  "datox.ve.issuer": "Delivering entity",
  "datox.ve.trading": "ValueExperts Trading",
  "datox.ve.consulting": "ValueExperts Consulting",
  "datox.ve.active": "Engagements",
  "datox.ve.actionNeeded": "Outstanding requests",
  "datox.ve.retained": "Retained entities",
  "datox.ve.upcoming": "Upcoming obligations",
  "datox.ve.overdue": "Overdue",
  "datox.ve.empty": "No engagements yet. Start by uploading your client documents.",
  "datox.ve.section.overview": "Overview",
  "datox.ve.section.documents": "Intake",
  "datox.ve.section.review": "Review & record",
  "datox.ve.section.tracker": "Execution tracker",
  "datox.ve.section.obligations": "Retainer obligations",
  "datox.ve.section.report": "Reports & Workflow",
  "datox.ve.section.activity": "Activity",
  "datox.ve.journey": "Your six-stage process",
  "datox.ve.owner": "Accountable owner",
  "datox.ve.due": "Due date",
  "datox.ve.status": "Status",
  "datox.ve.clientVisible": "Client-visible task",
  "datox.ve.clientPreview": "This flag describes the planned client view; this workspace is for internal users.",
  "datox.ve.requests": "Document request list",
  "datox.ve.received": "Received",
  "datox.ve.missing": "Outstanding",
  "datox.ve.documentType": "Document requirement",
  "datox.ve.upload": "Upload document",
  "datox.ve.versions": "Source documents & versions",
  "datox.ve.version": "Version {{version}}",
  "datox.ve.superseded": "Superseded source",
  "datox.ve.extract": "Extract with workflow agent",
  "datox.ve.extract.hint": "The existing report workflow agent extracts evidence-backed facts using the ValueExperts skill. A specialist approves the canonical record.",
  "datox.ve.source": "Download source",
  "datox.ve.evidence": "Evidence document",
  "datox.ve.evidence.choose": "Choose uploaded evidence",
  "datox.ve.page": "{{filename}} · page/section {{page}}",
  "datox.ve.noFacts": "Upload source documents and run extraction to begin the evidence review.",
  "datox.ve.conflict": "Conflicting source values — specialist review required",
  "datox.ve.approved": "Approved canonical value",
  "datox.ve.value": "Canonical value",
  "datox.ve.reason": "Review or change reason",
  "datox.ve.approve": "Approve this value",
  "datox.ve.record": "Reusable client record",
  "datox.ve.noApproved": "No facts have been approved yet.",
  "datox.ve.staleFact": "New extraction available — review this value again.",
  "datox.ve.dependencies": "Required predecessors: {{tasks}}",
  "datox.ve.none": "None",
  "datox.ve.override": "Authorized dependency override (reason required)",
  "datox.ve.saveTask": "Save task update",
  "datox.ve.manual": "Record a human-completed action and attach evidence. This does not submit to an authority.",
  "datox.ve.activate": "Activate / update retained obligations",
  "datox.ve.obligations.hint": "Complete the six-stage handover, then verify the stored registrations. Obligations derive from these dates and the annual renewals service.",
  "datox.ve.reminders.hint": "Use Email reminder to send a real message. Automatic reminder scheduling is not enabled. Reminder windows are configurable product settings, not statutory deadlines.",
  "datox.ve.reminders": "Reminder windows (days, comma-separated)",
  "datox.ve.verified": "I verified these registration identifiers, dates and evidence.",
  "datox.ve.registration": "Registration identifier",
  "datox.ve.kind.cr": "CR confirmation",
  "datox.ve.kind.misa": "MISA anniversary",
  "datox.ve.kind.gm_residency": "General manager residency check",
  "datox.ve.noObligations": "Activate a retained service to create dated obligations from verified registration records.",
  "datox.ve.dateRequired": "Date required",
  "datox.ve.reminderDue": "Within reminder window",
  "datox.ve.generate": "Generate client pack with agent",
  "datox.ve.report.hint": "The agent authors a branded draft from saved Output tables. It reuses reviewed facts, the live tracker and obligations without re-extraction.",
  "datox.ve.workflow": "Open shared Workflow",
  "datox.ve.pdf": "Export PDF",
  "datox.ve.html": "Download HTML",
  "datox.ve.csv": "Export tracker / records CSV",
  "datox.ve.report.stale": "This draft predates a case change. Generate a new revision before using it.",
  "datox.ve.report.none": "Approve the extracted facts, then generate the client pack.",
  "datox.ve.history": "Agent execution history",
  "datox.ve.history.empty": "No agent operations yet.",
  "datox.ve.activity.empty": "No activity recorded.",
  "datox.ve.refresh": "Refresh",
  "datox.ve.working": "Working…",
  "datox.ve.error": "The request could not complete. Refresh and try again.",
  "datox.ve.error.conflict": "This engagement changed. Refresh before continuing.",
  "datox.ve.error.forbidden": "You do not have permission for this action.",
  "datox.ve.error.input": "Check the required fields, current fact reviews, task dependencies and evidence before continuing.",
  "datox.ve.document.parent_certificate": "Parent incorporation certificate",
  "datox.ve.document.articles": "Articles of association",
  "datox.ve.document.board_resolution": "Board resolution",
  "datox.ve.document.gm_identity": "General manager identification",
  "datox.ve.document.ubo": "Ownership questionnaire",
  "datox.ve.document.legalisation": "Legalisation evidence",
  "datox.ve.document.evidence": "Manual milestone / registration evidence",
  "datox.ve.document.other": "Other supporting document",
  "datox.ve.status.intake": "Intake",
  "datox.ve.status.not_started": "Not started",
  "datox.ve.status.waiting_on_client": "Waiting on client",
  "datox.ve.status.ready_for_review": "Ready for review",
  "datox.ve.status.needs_review": "Needs review",
  "datox.ve.status.in_progress": "In progress",
  "datox.ve.status.submitted_externally": "Submitted externally",
  "datox.ve.status.query_received": "Query received",
  "datox.ve.status.completed": "Completed",
  "datox.ve.status.not_applicable": "Not applicable",
  "datox.ve.status.processing": "Agent processing",
  "datox.ve.status.queued": "Queued",
  "datox.ve.status.running": "Running",
  "datox.ve.status.failed": "Failed — retry required",
  "datox.ve.status.superseded": "Superseded",
  "datox.ve.status.interrupted": "Interrupted",
  "datox.ve.status.retained": "Retained",
  "datox.ve.status.setup_complete": "Setup complete · Ready for retained services",
  "datox.ve.status.overdue": "Overdue",
  "datox.ve.status.upcoming": "Upcoming",
  "datox.ve.status.date_required": "Date required",
  "datox.ve.operation.extraction": "Evidence extraction",
  "datox.ve.operation.report": "Report generation",
  "datox.listing.workflowType.valueexperts": "Corporate Services",
  "datox.ve.start": "Start an engagement",
  "datox.ve.start.hint": "Give the engagement a name, then upload your documents. No special filenames, forms or folder structure required.",
  "datox.ve.start.name": "Engagement or client name",
  "datox.ve.start.placeholder": "Enter your client or company name",
  "datox.ve.start.options": "Workspace & issuing company",
  "datox.ve.recent": "Continue an engagement",
  "datox.ve.noRecent": "Your engagements will appear here.",
  "datox.ve.step.documents": "Documents",
  "datox.ve.step.findings": "Review findings",
  "datox.ve.step.record": "Company record",
  "datox.ve.step.drafts": "Draft documents",
  "datox.ve.step.milestones": "Incorporation",
  "datox.ve.step.calendar": "Obligations",
  "datox.ve.step.description.documents": "Upload once. Extract company, ownership and manager information from your documents.",
  "datox.ve.step.description.findings": "Resolve inconsistent facts and see which supporting evidence is still missing.",
  "datox.ve.step.description.record": "Review one reusable record that will feed every document and ongoing service.",
  "datox.ve.step.description.drafts": "Create a resolution, a client summary and a document request from the same approved information.",
  "datox.ve.step.description.milestones": "Track incorporation and record actions your team completed outside the platform.",
  "datox.ve.step.description.calendar": "Turn verified registration dates and retained services into an accountable calendar.",
  "datox.ve.back": "Back",
  "datox.ve.continue": "Continue",
  "datox.ve.journey.progress": "Step {{step}} of 6",
  "datox.ve.supporting": "Workflow records & activity",
  "datox.ve.updated": "Engagement updated",
  "datox.ve.documents.add": "Add documents",
  "datox.ve.documents.drop": "Drop your documents here",
  "datox.ve.documents.hint": "Or choose files. The agent reads the content and identifies the document roles; no template matching required.",
  "datox.ve.documents.count": "{{count}} documents ready",
  "datox.ve.documents.empty": "Start with the documents you already have — company records, shareholder information, manager documents or correspondence.",
  "datox.ve.documents.pending": "Ready to analyze",
  "datox.ve.documents.read": "View source",
  "datox.ve.documents.extract": "Extract information",
  "datox.ve.documents.extracting": "Reading your documents…",
  "datox.ve.documents.extractProgress": "Verified {{completed}} of {{total}} documents…",
  "datox.ve.documents.retryProgress": "{{completed}} of {{total}} document results are saved. Retry extraction to resume unchanged sources.",
  "datox.ve.documents.processed": "Extracted information is ready for review.",
  "datox.ve.findings.empty": "Analyze your documents to see inconsistencies and missing evidence.",
  "datox.ve.findings.noExtractedFacts": "Analysis completed, but no company or person facts were extracted.",
  "datox.ve.findings.noExtractedFacts.hint": "Review the document limitations below, then retry extraction or upload readable source documents. An empty result does not confirm that the documents are consistent.",
  "datox.ve.findings.viewRecord": "View extracted company record",
  "datox.ve.findings.name": "Resolve inconsistent information",
  "datox.ve.findings.select": "Choose the value to keep in the company record.",
  "datox.ve.findings.reason": "Confirmed the selected value against the referenced source documents.",
  "datox.ve.findings.resolve": "Keep this value",
  "datox.ve.findings.resolved": "Resolved",
  "datox.ve.findings.clear": "No unresolved field inconsistencies",
  "datox.ve.findings.legalisation": "Legalisation evidence is missing",
  "datox.ve.findings.legalisation.hint": "A mention in a checklist or request does not count as the evidence itself. This item will appear in the generated document request.",
  "datox.ve.findings.evidenceFound": "Legalisation evidence identified",
  "datox.ve.findings.evidenceFound.hint": "Review the source before relying on it. Extracted evidence does not establish legal validity.",
  "datox.ve.findings.requests": "Outstanding document requests",
  "datox.ve.findings.next": "Build company record",
  "datox.ve.group.company": "Company",
  "datox.ve.group.ownership": "Shareholders & ownership",
  "datox.ve.group.manager": "General manager",
  "datox.ve.record.proposed": "Proposed from your documents",
  "datox.ve.record.saved": "Approved record · Ready to reuse",
  "datox.ve.record.confirm": "I have reviewed these values and their source evidence.",
  "datox.ve.record.approve": "Approve company record",
  "datox.ve.record.reason": "Reviewed the consolidated company, shareholder and manager record against its source evidence.",
  "datox.ve.record.conflict": "Resolve the remaining conflicting values before approving this record.",
  "datox.ve.record.source": "Source evidence for {{field}}",
  "datox.ve.record.edit": "Edit values",
  "datox.ve.record.done": "Done editing",
  "datox.ve.record.next": "Create draft documents",
  "datox.ve.draft.resolution": "Draft resolution",
  "datox.ve.draft.client_summary": "Client summary",
  "datox.ve.draft.document_request": "Document request",
  "datox.ve.draft.description.resolution": "Proposed incorporation, ownership and manager appointment clauses for adviser review.",
  "datox.ve.draft.description.client_summary": "A concise company, shareholder and manager profile from the approved record.",
  "datox.ve.draft.description.document_request": "Client-ready correspondence listing the missing evidence and open actions.",
  "datox.ve.draft.generate": "Generate draft",
  "datox.ve.draft.generating": "Generating…",
  "datox.ve.draft.regenerate": "Generate new revision",
  "datox.ve.draft.preview": "Preview draft",
  "datox.ve.draft.ready": "Draft ready",
  "datox.ve.draft.pending": "Not generated yet",
  "datox.ve.draft.needsRecord": "Approve the company record for resolutions and summaries. Document requests can be generated immediately after analysis.",
  "datox.ve.draft.shared": "All three documents use the same approved record. Each draft is saved in the existing Workflow with its source lineage.",
  "datox.ve.milestone.record": "Record an action",
  "datox.ve.milestone.blocked": "Completion requirements outstanding",
  "datox.ve.milestone.details": "Owner, date & exceptions",
  "datox.ve.milestone.note": "What happened?",
  "datox.ve.milestone.note.placeholder": "Describe the action completed by your team",
  "datox.ve.milestone.save": "Save action",
  "datox.ve.milestone.cancel": "Cancel",
  "datox.ve.milestone.exception": "Approved exception",
  "datox.ve.milestone.evidence": "Upload action evidence",
  "datox.ve.milestone.external": "Government actions are performed by your team. This view records their status and evidence.",
  "datox.ve.calendar.setup": "Create the obligations calendar",
  "datox.ve.calendar.services": "Retained services",
  "datox.ve.service.corporate_renewals": "Corporate registrations & renewals",
  "datox.ve.service.immigration_support": "Manager & immigration support",
  "datox.ve.service.retainer_review": "Retainer service reviews",
  "datox.ve.kind.retainer_review": "Retainer service review",
  "datox.ve.calendar.dates": "Verify the dates to monitor",
  "datox.ve.calendar.candidate": "Proposed from uploaded evidence — confirm before activation.",
  "datox.ve.calendar.manual": "Enter a verified date or leave it as Date required.",
  "datox.ve.calendar.confirm": "I confirm the selected services, registration details, dates and source evidence.",
  "datox.ve.calendar.activate": "Create calendar",
  "datox.ve.calendar.update": "Update registrations & services",
  "datox.ve.calendar.locked": "Complete incorporation and handover before activating ongoing services.",
  "datox.ve.calendar.previous": "Previous month",
  "datox.ve.calendar.next": "Next month",
  "datox.ve.calendar.month": "Calendar month",
  "datox.ve.calendar.upcoming": "Dates to watch",
  "datox.ve.calendar.unscheduled": "Date required",
  "datox.ve.calendar.origin": "Date source: {{source}}",
  "datox.ve.calendar.configure": "Registration details",
  "datox.ve.calendar.pickSource": "Select an extracted registration, or enter details manually",
  "datox.ve.calendar.manualSource": "Enter manually",
  "datox.ve.calendar.noDates": "No dated obligations yet. Verify registration dates and select retained services to create the calendar.",
  "datox.ve.calendar.mon": "Mon",
  "datox.ve.calendar.tue": "Tue",
  "datox.ve.calendar.wed": "Wed",
  "datox.ve.calendar.thu": "Thu",
  "datox.ve.calendar.fri": "Fri",
  "datox.ve.calendar.sat": "Sat",
  "datox.ve.calendar.sun": "Sun",
  "datox.ve.source.close": "Close source evidence",
  "datox.ve.document.intake": "Client information",
  "datox.ve.document.registration": "Registration or renewal record",
  "datox.ve.document.reference": "Reference or example",
  "datox.ve.document.example": "Example output",
  "datox.ve.error.missingDocuments": "The document pack is incomplete. Review the missing checklist items below; selecting action evidence does not satisfy them automatically.",
  "datox.ve.error.missingPredecessors": "Complete the prerequisite milestones shown below, or record an authorised exception with a reason.",
  "datox.ve.error.unreviewedFields": "Approve the current parent company, Saudi entity and general manager facts before completing this step.",
  "datox.ve.error.missingActionEvidence": "Select an evidence attachment for the externally submitted or completed action.",
  "datox.ve.blockers.title": "Still needed before completion",
  "datox.ve.blockers.predecessor": "Complete prerequisite: {{title}}",
  "datox.ve.blockers.evidenceDifference": "Action evidence records what you did. Each missing checklist requirement must also be satisfied and reviewed.",
  "datox.ve.blockers.review": "Review an attachment against this requirement",
  "datox.ve.blockers.reviewHint": "Select the actual supporting document and confirm that you have checked it. This records your specialist review; it does not infer compliance from a filename.",
  "datox.ve.blockers.confirm": "I have reviewed this attachment and confirm it satisfies: {{title}}.",
  "datox.ve.blockers.accept": "Record requirement review",
  "datox.ve.blockers.upload": "Upload supporting evidence",
  "datox.ve.blockers.actionEvidence": "Evidence of this action",
  "datox.ve.blockers.supportingDocument": "Document satisfying the requirement",
  "datox.ve.blockers.exceptionHint": "For an intentional exception, use Owner, date & exceptions and record the reason. Missing facts still require review.",
  "datox.ve.mail.compose": "Compose email",
  "datox.ve.mail.close": "Close",
  "datox.ve.mail.from": "From: {{sender}}",
  "datox.ve.mail.recipient": "Recipient email",
  "datox.ve.mail.subject": "Subject",
  "datox.ve.mail.message": "Message",
  "datox.ve.mail.attachment": "Draft PDF attached: {{title}}",
  "datox.ve.mail.actualSend": "Send email submits this message to the configured email service. Review the recipient and content first.",
  "datox.ve.mail.send": "Send email",
  "datox.ve.mail.document": "Email draft PDF",
  "datox.ve.mail.request": "Email document request",
  "datox.ve.mail.statusUpdate": "Email status update",
  "datox.ve.mail.reminder": "Email reminder",
  "datox.ve.mail.history": "Email activity",
  "datox.ve.mail.acceptanceNote": "Accepted means the email service accepted the message. It is not a confirmed inbox-delivery or read receipt.",
  "datox.ve.mail.status.queued": "Queued",
  "datox.ve.mail.status.sending": "Sending",
  "datox.ve.mail.status.accepted": "Accepted by email service",
  "datox.ve.mail.status.failed": "Failed",
  "datox.ve.mail.status.unknown": "Delivery unconfirmed",
  "datox.ve.mail.error.generic": "The email could not be prepared or sent. Check the message and service configuration.",
  "datox.ve.mail.error.email_not_configured": "No email provider is configured. Configure Microsoft 365 or SMTP before sending; no message has been sent.",
  "datox.ve.mail.error.email_auth_failed": "The email service could not authenticate. Ask an administrator to check the configured mailbox and credentials.",
  "datox.ve.mail.error.provider_rejected": "The email provider rejected the send request. Check the recipient and mailbox sending permissions.",
  "datox.ve.mail.error.provider_unavailable": "The email provider could not be reached before sending.",
  "datox.ve.mail.error.delivery_unknown": "Delivery could not be confirmed. Check Sent Items or the recipient before composing another message; this email will not be automatically resent.",
  "datox.ve.mail.error.attachment_too_large": "The PDF exceeds the email attachment limit. Download it and use your approved sharing channel.",
  "datox.ve.mail.error.invalid_email": "Enter one valid recipient email and a single-line subject.",
  "datox.ve.mail.error.email_attachment_unavailable": "The selected draft is unavailable or out of date. Generate a current draft before emailing it.",
  "datox.ve.mail.error.email_attachment_changed": "The selected document changed before sending. Review the latest version and compose a new email.",
  "datox.ve.mail.error.email_case_changed": "The engagement changed before this email was sent. Review the latest information and compose a new email.",
  "datox.ve.mail.error.email_access_or_attachment_changed": "Your access or the selected document changed before sending. No send was attempted.",
  "datox.ve.mail.error.email_pdf_failed": "The PDF attachment could not be prepared. Check the report export and compose the email again.",
  "datox.ve.mail.error.email_failed": "The email could not be prepared. No message was sent.",
} as const
